import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

function getVisitorId() {
  try {
    let v = localStorage.getItem('dyssc_vid');
    if (!v) {
      v = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem('dyssc_vid', v);
    }
    return v;
  } catch {
    return null;
  }
}

// ---- Google Analytics 4 (gtag.js loaded in public/index.html) ----
export function gaEvent(name, params = {}) {
  try {
    if (typeof window.gtag === 'function') window.gtag('event', name, params);
  } catch {}
}

export const gaCartItem = (item, qty) => ({
  item_id: item.productId || item.slug,
  item_name: item.name,
  price: item.priceINR,
  quantity: qty || item.qty || 1,
});

let lastPath = null;
let lastAt = 0;

// Fire-and-forget pageview tracking for the public storefront.
export function trackPageview(path) {
  const now = Date.now();
  if (path === lastPath && now - lastAt < 1500) return; // dedupe StrictMode / rapid re-renders
  lastPath = path;
  lastAt = now;
  gaEvent('page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
  const visitorId = getVisitorId();
  if (!visitorId || !API) return;
  axios
    .post(`${API}/api/analytics/pageview`, { visitor_id: visitorId, path, referrer: document.referrer || '' }, { timeout: 4000 })
    .catch(() => {});
}
